import {
  faArrowLeftLong,
  faCoins,
  faFileContract,
  faLink,
  faMarker,
  faPersonChalkboard,
  faQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADEMICYEARID,
  ACADIMAC,
  ADDLESSON,
  ADDMONTH,
  ADDQUESTIONS,
  baseURL,
  EDITQUESTION,
  UPDATEQUESTION,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { useLocation } from "react-router-dom";
export default function UpdateQuestion() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const [Academacs, setAcademacs] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [data, setData] = useState({
    question: "",
    chapter: "",
    grade: "",
    answare: "",
    choices: "",
  });

  function handleChange(e) {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${EDITQUESTION}/${id}`)
        .then((res) => {
          setData({
            academicYear: res.data.data.academic_year_id || "",
            chapter: res.data.data.chapter_id || "",
            question: res.data.data.question || "",
            grade: res.data.data.grade || "",
            answare: res.data.data.answer || "",
            choices: res.data.data.choices || "",
          });
          setSelectedOption(res.data.data.selectedOption || res.data.data.answer || "");
          setQuestionType(res.data.data.question_type || res.data.data.questionType || "");
          setOptionsText(res.data.data.choices || {});
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الشهر");
        });
    }
  }, [id, axiosPrivate]);

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const response = await axiosPrivate.put(`${baseURL}/${UPDATEQUESTION}`, {
        id,
        ...data,
        save,
        questionType,
        selectedOption,
        optionsText,
      });

      toast.success("تم الحفظ بنجاح");

      setData((prev) => ({
        ...prev,
        question: "",
        grade: "",
        answare: "",
        choices: "",
      }));

      if (nav) {
        Navigate("/DashboardLayout/tests/create-question");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);

      if (error.response && error.response.status === 400) {
        toast.error("لم يتم الحفظ، قد تكون البيانات مكررة أو غير صحيحة");
      } else {
        toast.error("حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً");
      }
    } finally {
      setLoding(false);
    }
  }

  const [questionType, setQuestionType] = useState("mcq");
  const [selectedOption, setSelectedOption] = useState(null);
  const [optionsText, setOptionsText] = useState({});

  useEffect(() => {
    async function featchmonth() {
      const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);

      setAcademacs(res.data.data);
    }

    featchmonth();
  }, [axiosPrivate]);

  useEffect(() => {
    async function featchmonth() {
      if (data.academicYear) {
        const res = await axiosPrivate.get(
          `${baseURL}/${ACADEMICYEARID}/${data.academicYear}`
        );
        setSelectData(res.data.data);
      }
    }
    featchmonth();
  }, [data.academicYear, axiosPrivate]);

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/tests/create-question"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold"> سوال اختبار</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="mb-5" controlId="city">
              <Form.Label> المرحلة الدراسيه</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicYear"
                value={data.academicYear}
                onChange={handleChange}
              >
                <option value="">----</option>
                {Academacs.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-5" controlId="city">
              <Form.Label> الشهر الدراسي:</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="chapter"
                value={data.chapter}
                onChange={handleChange}
              >
                <option value="">----</option>
                {selectData.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="question"
                value={data.question}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faQuestion} />
                <span className="textinpout"> السوال </span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="grade"
                value={data.grade}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faMarker} />

                <span className="textinpout">درجه السوال </span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5" controlId="city">
              <Form.Label> نوع الاسوال:</Form.Label>
              <Col sm="4">
                <Form.Select
                  required
                  className="custom-select"
                  value={questionType}
                  onChange={(e) => setQuestionType(e.target.value)}
                >
                  <option value="mcq">mcq</option>
                  <option value="truefalse">صح / خطأ</option>
                  <option value="text">مقالي</option>
                </Form.Select>
              </Col>
            </Form.Group>

            {/* الاختيارات */}

            {questionType === "mcq" &&
              [1, 2, 3, 4].map((optionValue, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center border rounded p-2 m-4"
                  style={{ gap: "15px" }}
                >
                  {/* Radio Button */}
                  <Form.Check
                    type="radio"
                    name="answermcq"
                    checked={selectedOption === optionValue}
                    readOnly
                    className="custom-radio"
                    onClick={() => setSelectedOption(optionValue)}
                  />

                  {/* Input Field */}
                  <Form.Control
                    type="text"
                    placeholder={`اكتب نص الاختيار ${optionValue}`}
                    value={optionsText[optionValue - 1] || ""}
                    onChange={(e) =>
                      setOptionsText({
                        ...optionsText,
                        [optionValue]: e.target.value,
                      })
                    }
                  />
                </div>
              ))}

            {questionType === "truefalse" &&
              ["صح", "خطأ"].map((label, index) => (
                <Form.Group
                  key={index}
                  style={{
                    cursor: "pointer",
                    position: "relative",
                    width: "90%",
                  }}
                  className="mb-3"
                  onClick={() => setSelectedOption(index + 1)}
                >
                  <div
                    className="d-flex align-items-center border rounded p-2"
                    style={{ gap: "10px" }}
                  >
                    {/* Radio Button */}
                    <Form.Check
                      type="radio"
                      name="answer"
                      checked={selectedOption === index + 1}
                      readOnly
                      className="custom-radio"
                    />

                    {/* كلمة صح أو خطأ */}
                    <span className="fw-bold">{label}</span>
                  </div>
                </Form.Group>
              ))}

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                إضافة
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
